import * as TYPES from '../types';

const initialState = {
    announcementList: [],
};

export function AnnouncementReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_ANNOUNCEMENTS_SUCCESS:
            return {
                ...preState,
                announcementList: payload,
            };

        default:
            return state;
    }
}